import { APIS } from '../../../utils/apiConfig';
import { createRequestUtility } from '../../../utils/httpUtils';
import { HttpService } from '../../HttpService/HttpService';

export class SubAdminService {
  // constructor(private httpService: HttpService) {}
  private makeRequest: ReturnType<typeof createRequestUtility>;

  constructor(private httpService: HttpService) {
    // Initialize makeRequest with the httpService
    this.makeRequest = createRequestUtility(this.httpService);
  }

  async addSubAdminAccount(params: any): Promise<any> {
    return this.makeRequest('post', APIS.ADD_SUB_ADMIN_ACCOUNT(), params);
  }
  async listAllFeatures(): Promise<any> {
    return this.makeRequest('get', APIS.LIST_SUPER_ADMIN_FEATURES(), {});
  }

  async getALLSubAdminDetails(): Promise<any> {
    try {
      const response = await this.httpService.get('/superAdmin/subadmin/list');
      const { data } = response;
      if (data.sc == 1) {
        const { result } = data;
        // authService.setAuth(result.token);
        return result;
      }
    } catch (e) {
      throw e;
    }
  }
}
